angular.module('logbook')
	.run(['editableOptions', 'editableThemes', function(editableOptions, editableThemes) {
		editableOptions.theme = 'bs3';
		editableThemes['bs3']['submitTpl'] = '<button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span></button>';
		editableThemes['bs3']['cancelTpl'] = '<button type="button" class="btn btn-default" ng-click="$form.$cancel()"><span class="glyphicon glyphicon-remove"></span></button>';
	}]);